module.exports = __webpack_public_path__ + "img/cat-empty-hogar.d4ac09fc.svg";